import { useSelector, useDispatch } from 'react-redux';

import DataGrid from 'app/components/DataGrid';
import useMembers from 'app/hooks/useMembers';
import MemberModal from './MemberModal';
import classes from './classes.module.scss';

const Members = props => {
  const account = useSelector(state => state.portalReducer.account);
  const dispatch = useDispatch();

  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onQuickAdd,
    onQuickEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData
  } = useMembers();

  const roleOptions = [
    { label: 'Standard User (non-admin)', value: 0 },
    { label: 'Photographer (isolated account)', value: 2 },
    { label: 'Admin (full access)', value: 1 },
  ]

  const statusOptions = [
    { label: 'Accpeted', value: 0 },
    { label: 'Pending', value: 1 },
  ]

  const header = 'Members';
  const addButtonLabel = 'Add Member';
  const omitColumns = ['message'];
  const columnOrder = ['name', 'email', 'phone', 'role', 'status', 'message'];
  const visibleColumns = [].concat(columnOrder);

  const columnDefOverrides = [
    {
      field: 'role',
      inputType: 'select',
      inputOptions: roleOptions,
      quickEdit: true,
      cellRenderer: params => {
        let data = params.data;
        if (data) {
          let role = roleOptions.find(o => {
            return o.value === data.role;
          });
          let text = role?.label;
          return <span className={classes.cell}>{text}</span>;
        }
        return '';
      }
    },
    {
      field: 'status',
      inputType: 'select',
      inputOptions: statusOptions,
      quickEdit: false, // default but explicit here
      cellRenderer: params => {
        let data = params.data;
        if (data) {
          let statuses = {
            '0': 'Accepted',
            '1': 'Pending'
          }
          let text = statuses[data.status.toString()];
          return <span className={classes.cell}>{text}</span>;
        }
        return '';
      }
    }
  ]

  const actions = [
    { key: 'destroy', label: 'Delete Members', callback: onDestroy }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        onQuickAdd={onQuickAdd}
        onQuickEdit={onQuickEdit}
        showFilters={showFilters}
        showSelect={true}
        actions={actions}
        loadingMessage="Loading members..."
        columnOrder={columnOrder}
        visibleColumns={visibleColumns}
        columnDefOverrides={columnDefOverrides}
        omitColumns={omitColumns}
        onDataGridLoad={onDataGridLoad}
      />
      <MemberModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        member={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
      />
    </div>
  );
}

export default Members;
